import React from 'react';
import { IoMdClose } from 'react-icons/io';
import QBIcon from '../assets/icons/QB.svg';
import type { FeeItem } from '../pages/client_shadcn';

type FeesProps = {
  data: FeeItem[];
  active: boolean;
  selectedFees: number[];
  feesFilter: {
    status: string | null
  },
  exportFunction(): void;
  cancelFunction(): void;
  checkRowFunction(row: number): void;
  checkAllRowsFunction(): void;
  handleFeesFilter(filter_name: string, filter_value: string): void;
};

const FeesModal = (props: FeesProps) => {
  const {
    data,
    active,
    selectedFees,
    feesFilter,
    exportFunction,
    cancelFunction,
    checkRowFunction,
    checkAllRowsFunction,
    handleFeesFilter,
  } = props;

  return (
    <>
      <div className={`fees_modal_container ${active ? 'active' : ''}`}>
        <div className="fees_modal">
          <div className="fees_modal_header">
            <div className="fees_title">
              <QBIcon className="qb_icon" />
              <span>Send to QuickBooks</span>
            </div>

            <div onClick={() => cancelFunction()} className="fees_close">
              <IoMdClose className="fees_close_icon" />
            </div>
          </div>

          <div className="fees_modal_table_container">
            <div className="fees_modal_table_actions_container">
              <div className="fees_modal_table_actions_title">
                <span>Include fees</span>
              </div>

              <div className="fees_modal_table_actions">
                <div className="fees_modal_table_actions_checkbox">
                  <input
                    id="hide_estimated"
                    type="checkbox"
                    className="checkbox"
                    checked={feesFilter && feesFilter.status ? true : false}
                    onChange={(e) => handleFeesFilter('status', e.target.checked ? 'Not Estimated' : '')}
                  />
                </div>

                <div className="fees_modal_table_actions_checkbox_title">
                  <label htmlFor="hide_estimated">Hide previously estimated</label>
                </div>
              </div>
            </div>

            <div className="fees_modal_table">
              <div className="fees_modal_table_header">
                <div className="th">
                  <div className="flex items-center justify-center">
                    <input
                      type="checkbox"
                      className={`checkbox ${selectedFees.length === data.length ? '' : 'minus'}`}
                      checked={selectedFees && selectedFees.length > 0}
                      onChange={() => checkAllRowsFunction()}
                    />
                  </div>
                </div>

                {selectedFees && selectedFees.length > 0 ? (
                  <div className="th">
                    <span>{selectedFees.length} selected</span>
                  </div>
                ) : (
                  <div className="th underline cursor-pointer">
                    <span>Fee Type</span>
                  </div>
                )}

                <div className="th text-right underline cursor-pointer">
                  <span>Status</span>
                </div>

                <div className="th text-center">
                  <span>Qty.</span>
                </div>

                <div className="th text-right">
                  <span>Total Price</span>
                </div>
              </div>

              <div className="fees_modal_table_body">
                {data &&
                  data.length > 0 &&
                  data.map((item: FeeItem) => {
                    return (
                      <div className={`row ${selectedFees.includes(item.id) ? 'selected' : ''}`}>
                        <div className="flex items-center items-center">
                          <div className="flex items-center items-center">
                            <input
                              type="checkbox"
                              className="checkbox"
                              checked={selectedFees.includes(item.id)}
                              onChange={() => checkRowFunction(item.id)}
                            />
                          </div>
                        </div>

                        <div className="td">
                          <div>
                            <span>{(item.item && item.item.name) || 'Select'}</span>
                          </div>

                          <div>
                            <span>{item.feeDescription || ''}</span>
                          </div>
                        </div>

                        <div className="td items-end text-right">
                          <span>{item.status || 'Not Estimated'}</span>
                        </div>

                        <div
                          className="td text-center items-end"
                          style={{ wordWrap: 'break-word', wordBreak: 'break-all' }}
                        >
                          <span>{item.quantity || ''}</span>
                        </div>

                        <div className="td items-end text-right">
                          <span>${item.totalPrice || '0.00'}</span>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="fees_modal_actions">
            <div className="fees_modal_actions_buttons">
              <div>
                <button
                  style={{ fontWeight: '500', fontSize: '14px' }}
                  type="button"
                  onClick={() => cancelFunction()}
                >
                  Cancel
                </button>
              </div>

              <div>
                <button className="export_qb_btn" type="button" onClick={() => exportFunction()}>
                  Export to QuickBooks
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div onClick={() => cancelFunction()} className={`fees_overlay ${active ? 'active' : ''}`} />
    </>
  );
};

export default FeesModal;
